module.exports = __webpack_public_path__ + "img/symbol_2.26b1e4f4.png";